var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "shopCartMain",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.consoleInfo("main click")
        }
      }
    },
    [
      _c("div", { staticClass: "frame" }, [
        _c("div", { staticClass: "productSpecificationListFrameHeader" }, [
          _c("div", [_vm._v("已选商品")]),
          _vm._v(" "),
          _c("div", { staticStyle: { "flex-grow": "1" } }),
          _vm._v(" "),
          _c("button", { on: { click: _vm.clearCart } }, [_vm._v("清空购物车")])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "horizonGully",
          staticStyle: { "flex-shrink": "0" }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "horizonDivider",
          staticStyle: { "flex-shrink": "0" }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "horizonGully",
          staticStyle: { "flex-shrink": "0" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "productSpecificationListFrameContent" },
          _vm._l(_vm.cartInfo.shoppingCars, function(item, index) {
            return _c(
              "div",
              {
                key: item.productInfo.pId + "_" + item.specificationId,
                staticClass: "productWrapper"
              },
              [
                _c("input", {
                  staticClass: "selector",
                  attrs: { type: "checkbox" },
                  domProps: { checked: _vm.selectProductList[index] },
                  on: {
                    click: function($event) {
                      return _vm.selectProduct(index)
                    }
                  }
                }),
                _vm._v(" "),
                _c("ProductOfCart", {
                  staticClass: "productOfCart",
                  attrs: {
                    shopId: _vm.shopId,
                    productImg: item.productInfo.pPic_1,
                    productName: item.productInfo.pName,
                    productId: item.productInfo.pId,
                    productPrice: item.productInfo.pNowPrice,
                    productNumber: item.snum,
                    specificationId: item.specificationId,
                    specificationName: item.specificationName,
                    shelfId: item.shelfId,
                    stock: item.productInfo.pStock
                  }
                })
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "productSpecificationListFrameBottom" }, [
          _c("div", { staticClass: "horizonGully" }),
          _vm._v(" "),
          _c("div", { staticClass: "horizonDivider" }),
          _vm._v(" "),
          _c("div", { staticClass: "horizonGully" }),
          _vm._v(" "),
          _c("div", { staticClass: "operatePanel" }, [
            _c(
              "div",
              {
                staticStyle: { "flex-shrink": "0" },
                on: { click: _vm.selectAll }
              },
              [
                _c("input", {
                  attrs: { type: "checkbox", id: "selectAll" },
                  domProps: { checked: _vm.ifSelectAll }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "selectAll" } }, [_vm._v("全选")])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "flex-grow": "1" } }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticStyle: { "flex-shrink": "0" },
                on: { click: _vm.commitOrder }
              },
              [_vm._v(_vm._s(_vm.commitOrderText))]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "verticalGully",
              staticStyle: { "flex-shrink": "0" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticStyle: { "flex-shrink": "0" },
                on: { click: _vm.removeDialog }
              },
              [_vm._v("关闭")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }